import { render, staticRenderFns } from "./MeterDataExchange.yaml?vue&type=template&id=6cf2bf4c&component"
import script from "./MeterDataExchange.yaml?vue&type=script&lang=ts&component"
export * from "./MeterDataExchange.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports